export type StatisticsTranslation = {
  filters: {
    monthFrom: string;
    monthTo: string;
    processes: string;
    recruiters: string;
    reset: string;
    search: string;
  };
  table: {
    initialCount: string;
    loading: string;
    noData: string;
    process: string;
    recruiter: string;
    recruiterSummary: string;
    repeatedCount: string;
    total: string;
  };
  title: string;
};

export const statisticsTranslation: StatisticsTranslation = {
  filters: {
    monthFrom: 'Month from',
    monthTo: 'Month to',
    processes: 'Processes',
    recruiters: 'Recruiters',
    reset: 'Reset',
    search: 'Search',
  },
  table: {
    initialCount: 'No. of analysis',
    loading: 'Loading...',
    noData: 'No data to display',
    process: 'Process',
    recruiter: 'Recruiter',
    recruiterSummary: 'Recruiter summary',
    repeatedCount: 'No. of repeated analysis',
    total: 'Total',
  },
  title: 'CV Processing Statistics',
};
